import { render, staticRenderFns } from "./GuideCard.vue?vue&type=template&id=18d31eee&scoped=true"
import script from "./GuideCard.vue?vue&type=script&lang=js"
export * from "./GuideCard.vue?vue&type=script&lang=js"
import style0 from "./GuideCard.vue?vue&type=style&index=0&id=18d31eee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d31eee",
  null
  
)

export default component.exports